import { render, staticRenderFns } from "./EnergyDatasheetLink.vue?vue&type=template&id=59dc84f6&"
import script from "./EnergyDatasheetLink.vue?vue&type=script&lang=js&"
export * from "./EnergyDatasheetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Misha\\Documents\\GitHub\\energy_label_plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59dc84f6')) {
      api.createRecord('59dc84f6', component.options)
    } else {
      api.reload('59dc84f6', component.options)
    }
    module.hot.accept("./EnergyDatasheetLink.vue?vue&type=template&id=59dc84f6&", function () {
      api.rerender('59dc84f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/EnergyDatasheetLink.vue"
export default component.exports